import React from 'react';
import './pedido-reprint.css';

const PedidoReprintView = (props) => {
  const prop = props.onProps || {};
  const articulos = Array.isArray(prop.articulos) ? prop.articulos : [];
  const mode = (props.mode || prop.printMode || 'auto').toString().toLowerCase();

  const hasTurn = prop.turn !== undefined && prop.turn !== null && prop.turn !== '';
  const hasInvoice = !!(prop.invoice && String(prop.invoice).trim() !== '');
  const autoShowCaja = !hasInvoice || prop.rfc === '' || prop.rfc === 'XAXX010101000';
  const autoShowAlmacen = ['004', '007', '006', '003'].includes(prop.area) || hasInvoice;

  const showCaja =
    mode === 'caja' ? true :
    mode === 'almacen' ? false :
    mode === 'both' ? true :
    autoShowCaja;

  const showAlmacen =
    mode === 'caja' ? false :
    mode === 'almacen' ? true :
    mode === 'both' ? true :
    autoShowAlmacen;

  const almacenContainerStyle = {
    marginTop: '10px',
    ...(showCaja && showAlmacen ? { pageBreakBefore: 'always', breakBefore: 'page' } : {}),
  };
  const watermarkText = String(
    prop.watermarkText || prop.watermark_text || ''
  ).trim();
  const showWatermark = watermarkText !== '';

  function isEnvioLine(p) {
    const code = String(p?.productCode || '').trim();
    const loc = String(p?.location || '').trim();
    const name = String(p?.product || '').trim().toUpperCase();
    const color = String(p?.color || '').trim().toUpperCase();

    if (p?.isShipping === true || p?.isEnvio === true) return true;

    const looksLikeServiceName =
      /^(PMM\d*|T00\d|TEAMEX|DHL|INBOX|PAQUET|ENVIO)/i.test(name) ||
      /^[A-Z]{2,6}\d{0,3}$/.test(name);

    const codeLooksLikeNotAProduct = code === '' || code.length <= 2;
    const colorLooksService = color === '' || color.includes('SIN COLOR');

    return (loc === '' && codeLooksLikeNotAProduct && colorLooksService && name !== '' && looksLikeServiceName);
  }

  function parseLocation(loc) {
    if (!loc) return { piso: -1, rack: -1, seccion: -1, nivel: -1 };

    const s = String(loc).trim().toUpperCase();
    const m = s.match(/P(\d+)\s*[-\s]*R(\d+)\s*[-\s]*([A-Z]+)\s*[-\s]*(\d+)/i);
    if (!m) return { piso: -1, rack: -1, seccion: -1, nivel: -1 };

    const piso = parseInt(m[1], 10);
    const rack = parseInt(m[2], 10);
    const seccStr = m[3];
    const nivel = parseInt(m[4], 10);

    let seccion = 0;
    for (let i = 0; i < seccStr.length; i++) {
      seccion = seccion * 26 + (seccStr.charCodeAt(i) - 64); 
    }

    return { piso, rack, seccion, nivel };
  }

  function compareLocationDesc(aLoc, bLoc) {
    const a = parseLocation(aLoc);
    const b = parseLocation(bLoc);

    if (a.piso !== b.piso) return b.piso - a.piso;
    if (a.rack !== b.rack) return b.rack - a.rack;
    if (a.seccion !== b.seccion) return b.seccion - a.seccion;
    if (a.nivel !== b.nivel) return b.nivel - a.nivel;
    return 0;
  }

  const articulosOrdenadosAlmacen = articulos
    .map((p, idx) => ({ ...p, __idx: idx }))
    .sort((a, b) => {
      const aEnv = isEnvioLine(a);
      const bEnv = isEnvioLine(b);

      if (aEnv && !bEnv) return -1;
      if (!aEnv && bEnv) return 1;

      const byLoc = compareLocationDesc(a.location, b.location);
      if (byLoc !== 0) return byLoc;

      return a.__idx - b.__idx;
    })
    .map(({ __idx, ...p }) => p);

  const userLS = (() => {
    try { return JSON.parse(localStorage.getItem('user')) || {}; } catch (e) { return {}; }
  })();

  const site = String(prop.site || userLS.site || '').trim();
  const showUbicaciones = site === '3000';

return (
  <div id="reprintContainer">
    {showWatermark && (
      <div className="pedido-watermark-global">
        {watermarkText}
      </div>
    )}

    {showCaja && (
      <div>
        <section className="print-section">           

            {hasTurn && (
              <div className="turno-badge-wrap">
                <div className="turno-badge-print">Turno: {prop.turn}</div>
              </div>
            )}

            <div>
              <h2>GRUPO MI PLAYERA DE MEXICO SA DE CV</h2>
              <table>
                <tbody>
                  <tr>
                    <td>
                      Folio: {prop.numeroPedido}<br />
                      Remisión: {prop.remision}<br />
                      Vendido a: {prop.cliente}<br />
                      Vendedor: {prop.vendedor}<br />
                      Usuario: {prop.usuario}<br />
                      Comentarios: {prop.comentarios}<br />
                      Dirección: {prop.direccion}<br />
                    </td>
                    <td>
                      Fecha: {prop.fecha}<br />
                      Status: {prop.status}<br />
                      Sub Total: $ {prop.subtotal}<br />
                      Descuento: $ {prop.descuento}<br />
                      IVA: $ {prop.iva}<br />
                      Total: $ {prop.total}<br />
                    </td>
                  </tr>
                </tbody>
              </table>

              <div>
                <table>
                  <thead>
                    <tr>
                      <th>Codigo</th>
                      <th>Articulo</th>
                      <th>Talla</th>
                      <th>Color</th>
                      <th>Cantidad</th>
                      <th>Precio</th>
                      <th>IVA</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {articulos.map((producto, index) => (
                      <tr key={index} style={{ fontSize: 12 }}>
                        <td>{producto.productCode}</td>
                        <td>{producto.product}</td>
                        <td>{producto.size}</td>
                        <td>{producto.color}</td>
                        <td>{producto.qtyOrd}</td>
                        <td>{producto.price}</td>
                        <td>{producto.IVA}</td>
                        <td>{producto.subTotal}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      )}

      {showAlmacen && (
        <div style={almacenContainerStyle}>
          <section className="print-section">

            <div className="almacen-header">
              <h1 style={{ marginTop: '10px', fontWeight: 'bold' }}>ALMACEN</h1>
              {hasTurn && <div className="turno-badge-print">Turno: {prop.turn}</div>}
            </div>

            <table>
              <tbody>
                <tr>
                  <td>
                    Folio: {prop.numeroPedido}<br />
                    Remisión: {prop.remision}<br />
                    Usuario: {prop.usuario}<br />
                    Vendedor: {prop.vendedor}<br />
                    Dirección: {prop.direccion}<br />
                  </td>
                  <td />
                  <td>
                    Fecha: {prop.fecha}<br />
                    Status: {prop.status}<br />
                    Vendido a: {prop.cliente}<br />
                    Factura: {prop.invoice}<br />
                    Comentarios: {prop.comentarios}<br />
                  </td>
                </tr>
              </tbody>
            </table>

            <div>
              <table className="almacen-items">
                <thead>
                  <tr>
                    <th>Codigo</th>
                    <th>Articulo</th>
                    <th>Talla</th>
                    <th>Color</th>
                    <th>Cantidad</th>
                    <th>Surtidor</th>
                    <th>Despacho</th>
                    {showUbicaciones && <th>Ubicaciónes</th>}
                  </tr>
                </thead>
                <tbody>
                  {articulosOrdenadosAlmacen.map((producto, index) => (
                    <tr key={index} style={{ fontSize: 12 }}>
                      <td>{producto.productCode}</td>
                      <td>{producto.product}</td>
                      <td>{producto.size}</td>
                      <td>{producto.color}</td>
                      <td>{producto.qtyOrd}</td>
                      <td><div className="rectangulo-almacen"></div></td>
                      <td><div className="rectangulo-almacen"></div></td>
                      {showUbicaciones && (
                        <td className="almacen-ubicacion">{producto.location || ''}</td>
                      )}
                    </tr>
                  ))}

                  <tr style={{ fontWeight: 'bold' }}>
                    <td colSpan={4}></td>
                    <td colSpan={showUbicaciones ? 4 : 3}>
                      Total Piezas {
                        articulosOrdenadosAlmacen.reduce((total, p) => {
                          const qty = parseFloat(p.qtyOrd);
                          return p.um === 'PZ' ? total + (isNaN(qty) ? 0 : qty) : total;
                        }, 0)
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export { PedidoReprintView as default };